import React, 
       { useEffect, 
         useState,
         useContext}                from 'react';
import { Container, 
         Button,
         Card,
         Row, 
         Col}                       from 'react-bootstrap';
import api                          from './AxiosConfig';
import CheckBoxDisplay              from './CheckBoxDisplay';
import DateDisplay                  from './DateDisplay';
import EditFloatValue               from './EditFloatValue';
import { SelectionContext }         from './SelectionContext';

function GoalProgressUpdateRM( { selGoal, refresh } ) {
  const [goal,            setGoal]            = useState();
  const [selSubGoal,      setSelSubGoal]      = useState();
  const [subGoalIds,      setSubGoalIds]      = useState([]);
  const [progressRecords, setProgressRecords] = useState([]);
  const [message,         setMessage]         = useState( "" );
  const [messageErr,      setMessageErr]      = useState( false );
  const { getExpandedCLSummary }             = useContext(SelectionContext);
       
 useEffect(() => {
    console.log("Checking SelGoal");
    if (selGoal) {
        if (!goal) {
            setGoal(selGoal);
        } else {
            if ( goal.id !== selGoal.id ) {
               setGoal(selGoal);
            } else {
               console.log("Goal Update Skipped.");
            }
        }
    console.log("selGoal = " + selGoal.id);
    }
  }, [selGoal]); // Runs when initialData changes

  useEffect(() => {
      async function getSubGoalIds() {
          console.log("getSubGoalIds()");
          if ( goal && goal.id ) {
              try {
                  const response = await api.get(`/site/radar-goals/${encodeURIComponent(goal.id)}`, {withCredentials: true });
                  setSubGoalIds(response.data);
                  setSelSubGoal(response.data[0].id);
              } catch (error) {
                  console.log("getSubGoalIds: " + error);
              }
          }
      }
      getSubGoalIds();
  }, [goal]); 

  useEffect(() => { 
       async function getSelectedProgress() {
           console.log("getSelectedProgress()");
           console.log("selSubGoal = " + selSubGoal );
           if ( selSubGoal  ) {
               try  {
                   const response = await api.get(`/site/radar-goals-progress/current/${encodeURIComponent(selSubGoal)}`, {withCredentials: true });
                   setProgressRecords( response.data );
                   refresh();
                   console.log("getSelectedProgress: call complete.");
               } catch (error) {
                   console.log("getSelectedProgress: " + error );
               }
           } else {
                setProgressRecords( [] );
           }
       } 
       getSelectedProgress();
       }, [selSubGoal] );

  // Format date for date form control.
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
           
  // Handle select option change
  const handleSelectChange = (event) => {
    console.log("handleSelectChange: " + event.target.value);
    setSelSubGoal(event.target.value);
  };
       
  const updateProgressValueAtIndex = (i, newValue, validValue) => {
      console.log("updateProgressValueAtIndex(" + i + ", " + newValue + ", " + validValue + ")");
      setProgressRecords(prev =>
          prev.map((item, idx) =>
          idx === i
          ? { ...item, value: newValue, is_measured: "1", valid: validValue }   
          : item                           
          )
       );
  };    
       
  const handleUpdateProgressRecords = async () => {
       try {
           var success = true;
           var msg     = "";
           for ( let c = 0; c < progressRecords.length ; c++ ){
               const response = await api.put(`/site/radar-goals-progress/${encodeURIComponent(selSubGoal)}/${encodeURIComponent(progressRecords[c].id)}`, { progressRecord: progressRecords[c] }, {withCredentials: true });
               msg = response.data.message;
               if ( !response.data.success) {
                   success = false;
                   break;
               }
           }
           setMessage( msg );
           setMessageErr( !success );
           if ( success ) {
               refresh();
           }
              
       } catch (error) {
           console.log("subGoalRow: " + error);
           setMessage( error );
           setMessageErr( true );
       }
  }

  console.log("progressRecords=" + JSON.stringify(progressRecords));
  return (
         <Container className="mt-2">
             <Row className="justify-content-md-center">
               <Col md="6">
                 <Card>
                 <Card.Header>
                 Update Progress (Goal = {selGoal.id})
                 </Card.Header>
                 <Card.Body>
                     <Card.Text>Select a Sub-Goal:</Card.Text>
                     <Card.Text>
                       <select value={selSubGoal} onChange={handleSelectChange}>
                         {subGoalIds?.map((option) => (
                           <option key={option.id} value={option.id}>
                               {option.name} ({option.start},{option.target})
                           </option>
                         ))}          
                       </select>
                     </Card.Text>

                     {progressRecords.length > 0 && progressRecords.map((pr, index) => (
                       <Row key={index} >
                          <Col>{formatDate(pr.date)}</Col>
                          <Col><EditFloatValue index={index} boxMeasured={pr.is_measured} boxValue={pr.value} onBoxChanged={updateProgressValueAtIndex}/></Col>
                       </Row>
                     ))}

                     <Row>
                       <Col className="text-center"><Button variant="primary" size="sm" onClick={() => handleUpdateProgressRecords()}>Update Progress</Button></Col>
                     </Row>
          </Card.Body>
      <Card.Footer>{message}</Card.Footer>       
      </Card>
      </Col>
      </Row>
    </Container>
  );       
}

export default GoalProgressUpdateRM;
